export default __webpack_public_path__ + "static/media/Coil of the Jiang Shi.8a0c8d7d.jpg";